import { create } from 'zustand';
import moment from 'moment';

export const initialState = {
    sellout_summary: {
        total_sku: 0,
        total_qty: 0,
        total_value: 0,
        total_final_value: 0,
        sellout_type: '',
        date_upload: moment(),
        total_success: 0,
        total_failed: 0,
        customer_id: '',
        customer_name: '',
        store_group_id: '',
        store_group: '',
        distribution_center: '',
        external_reference: '',
        start_date: '',
        end_date: '',
        smart_upload_filename: '',
    },
    data: {
        success_data: [],
        failed_data: [],
    },
    detail_error: [],
};
const toBigInt = (value) => BigInt(value ?? 0);

export const useDataKonversi = create((set) => ({
    ...initialState,
    setData: (newState) => set(newState),

    addData: (newItem) =>
        set((state) => ({
            sellout_summary: {
                ...state.sellout_summary,
                total_success: state.sellout_summary.total_success + 1,
                total_sku: state.sellout_summary.total_sku + 1,
                total_qty: toBigInt(state.sellout_summary.total_qty) + toBigInt(newItem.qty),
                total_value: toBigInt(state.sellout_summary.total_value) + toBigInt(newItem.customer_subtotal),
                total_final_value:
                    toBigInt(state.sellout_summary.total_final_value) + toBigInt(newItem.customer_final_subtotal),
            },
            data: {
                ...state.data,
                success_data: [newItem, ...state.data.success_data],
            },
        })),

    editData: (id, newData) =>
        set((state) => {
            const oldItem =
                state.data.success_data.find((item) => item.id === id) ||
                state.data.failed_data.find((item) => item.id === id);
            if (!oldItem) return state;
            return {
                sellout_summary: {
                    ...state.sellout_summary,
                    ...('qty' in newData
                        ? {
                              total_qty:
                                  toBigInt(state.sellout_summary.total_qty) -
                                  toBigInt(oldItem.qty) +
                                  toBigInt(newData.qty),
                          }
                        : {}),
                    ...('customer_subtotal' in newData
                        ? {
                              total_value:
                                  toBigInt(state.sellout_summary.total_value) -
                                  toBigInt(oldItem.customer_subtotal) +
                                  toBigInt(newData.customer_subtotal),
                          }
                        : {}),
                    ...('customer_final_subtotal' in newData
                        ? {
                              total_final_value:
                                  toBigInt(state.sellout_summary.total_final_value) -
                                  toBigInt(oldItem.customer_final_subtotal) +
                                  toBigInt(newData.customer_final_subtotal),
                          }
                        : {}),
                },
                data: {
                    ...state.data,
                    success_data: state.data.success_data.map((item) =>
                        item.id === id ? { ...item, ...newData } : item,
                    ),
                    failed_data: state.data.failed_data.map((item) =>
                        item.id === id ? { ...item, ...newData } : item,
                    ),
                },
            };
        }),

    moveData: (id, to) =>
        set((state) => {
            if (to !== 'success' && to !== 'failed') return state;
            const toSuccess = to === 'success';
            const toMoveData = toSuccess
                ? state.data.failed_data.find((item) => item.id === id)
                : state.data.success_data.find((item) => item.id === id);
            if (!toMoveData) return state;
            return {
                sellout_summary: {
                    ...state.sellout_summary,
                    total_success: state.sellout_summary.total_success + (toSuccess ? 1 : -1),
                    total_failed: state.sellout_summary.total_failed + (toSuccess ? -1 : 1),
                },
                data: {
                    success_data: toSuccess
                        ? [...state.data.success_data, toMoveData]
                        : state.data.success_data.filter((item) => item.id !== id),
                    failed_data: toSuccess
                        ? state.data.failed_data.filter((item) => item.id !== id)
                        : [...state.data.failed_data, toMoveData],
                },
            };
        }),

    deleteData: (id) =>
        set((state) => {
            const toDeleteData =
                state.data.success_data.find((item) => item.id === id) ||
                state.data.failed_data.find((item) => item.id === id);
            if (!toDeleteData) return state;
            const inSuccess = state.data.success_data.some((item) => item.id === id);
            return {
                sellout_summary: {
                    ...state.sellout_summary,
                    total_success: state.sellout_summary.total_success - (inSuccess ? 1 : 0),
                    total_failed: state.sellout_summary.total_failed - (inSuccess ? 0 : 1),
                    total_sku: state.sellout_summary.total_sku - 1,
                    total_qty: toBigInt(state.sellout_summary.total_qty) - toBigInt(toDeleteData.qty),
                    total_value: toBigInt(state.sellout_summary.total_value) - toBigInt(toDeleteData.customer_subtotal),
                    total_final_value:
                        toBigInt(state.sellout_summary.total_final_value) -
                        toBigInt(toDeleteData.customer_final_subtotal),
                },
                data: {
                    success_data: state.data.success_data.filter((item) => item.id !== id),
                    failed_data: state.data.failed_data.filter((item) => item.id !== id),
                },
            };
        }),

    resetData: () => set(initialState),
}));
